// Judge.me badges appear in product cards across recommendation carousels.
// Keep one formatter and observer instead of embedding the same script in every card.
(function() {
  if (window.__jdgmBadgeReformatInit) return;
  window.__jdgmBadgeReformatInit = true;

  var ratingRe = /(\d+(?:\.\d+)?)\s*\(\s*(\d[\d,.]*)\s*reviews?\s*\)/i;
  var countOnlyRe = /\(\s*(\d[\d,.]*)\s*\)/;

  function formatCount(value) {
    var number = parseInt(String(value).replace(/[^\d]/g, ''), 10);
    return isNaN(number) ? value : number.toLocaleString('en-US');
  }

  function formatRating(value) {
    var number = parseFloat(value);
    return isNaN(number) ? value : (Math.round(number * 10) / 10).toFixed(1) + '/5';
  }

  function reformat(node) {
    if (!node || !node.childNodes) return;

    node.childNodes.forEach(function(child) {
      if (child.nodeType === 3) {
        var text = child.nodeValue;
        var formattedText = text;
        if (ratingRe.test(text)) {
          formattedText = text.replace(ratingRe, function(_, rating, count) {
            return formatRating(rating) + ' (' + formatCount(count) + ' reviews)';
          });
        } else if (countOnlyRe.test(text) && /\d/.test(text)) {
          formattedText = text.replace(countOnlyRe, function(_, count) {
            return '(' + formatCount(count) + ')';
          });
        }
        if (formattedText !== text) child.nodeValue = formattedText;
      } else if (child.nodeType === 1) {
        reformat(child);
      }
    });
  }

  function run(root) {
    if (root && root.matches && root.matches('.jdgm-preview-badge, .jdgm-prev-badge')) {
      reformat(root);
    }
    if (root && root.querySelectorAll) {
      root.querySelectorAll('.jdgm-preview-badge, .jdgm-prev-badge').forEach(reformat);
    }
  }

  run(document);
  window.addEventListener('load', function() { run(document); }, { once: true });

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) run(node);
      });
      if (mutation.type === 'characterData' && mutation.target.parentElement) {
        var badge = mutation.target.parentElement.closest('.jdgm-preview-badge, .jdgm-prev-badge');
        if (badge) reformat(badge);
      }
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
